import { render } from "./Collection.vue?vue&type=template&id=642766b0"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"

import "./Collection.vue?vue&type=style&index=0&id=642766b0&lang=scss"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__